import windowNameKeys from '@/constants/window-name-keys';
import { windowService } from './window-service';

const openAppDownload = (url: string) => {
	windowService.openWindow(windowNameKeys.APP_DOWNLOAD, url, '_blank');
}

export const appDownloadService = {
	openAppDownload
}